import {DataObject} from "./DataObject";

export class DraftCover implements DataObject {
  ID: number;
  resource_ID: number;
  documentScale: number = 1;
  verticalShift: number = 0;
  horizontalShift: number = 0;
  paperType_ID: number = 3;
  barcodeSide: string = 'NONE';
  barcodeOrientationHorz: string = 'LEFT';
  barcodeOrientationVert: string = 'BOTTOM';
  barcodePaddingHorz: number = 0;
  barcodePaddingVert: number = 0;
  barcodePositionHorz: number = 36;
  barcodePositionVert: number = 36;
  isColorBoosted: string = 'FALSE';
  laminateType: string = 'GLOSS';
  lastUpdate: Date = new Date();

  constructor( obj ) {
    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  getId() {
    return this.ID;
  }

  getOrderValue() {
    return this.ID;
  }

  update(obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && (typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date)) {
          this[prop] = obj[prop];
        }
      }
    }
  }
}
